import React from 'react';

type StaffingEntityQuickDetailsProps = {
  code: string | null | undefined;
  facilityName: string | null | undefined;
  location: string | null | undefined;
  specialty: string | null | undefined;
};

export function StaffingEntityQuickDetails({
  code,
  facilityName,
  location,
  specialty,
}: StaffingEntityQuickDetailsProps) {
  return (
    <div className="tw:flex tw:flex-col tw:gap-1 tw:bg-brand-green-0/10 tw:rounded-lg tw:p-4 tw:text-zinc-700 tw:leading-tight">
      <span className="tw:!mb-0 tw:text-lg tw:font-bold">{code || 'Untitled'}</span>
      <div className="tw:grid tw:grid-cols-[auto_1fr] tw:gap-x-2 tw:gap-y-2 tw:mt-1 tw:items-center">
        <i className="fa-solid fa-hospital tw:text-brand-green-0 tw:justify-self-center" />
        <span className="tw:justify-self-start">{facilityName || 'Unknown Facility'}</span>
        <i className="fa-solid fa-location-dot tw:text-brand-green-0 tw:justify-self-center" />
        <span className="tw:justify-self-start">{location || '--'}</span>
        <i className="fa-solid fa-stethoscope tw:text-brand-green-0 tw:justify-self-center" />
        <span className="tw:justify-self-start">{specialty || '--'}</span>
      </div>
    </div>
  );
}
